module.exports = __webpack_public_path__ + "static/media/terraspeak-logo.99131974.jpg";